import get from "lodash/get";
import { Block } from "./Block";
import { Img } from "./Image";

export class Page {
  constructor(node) {
    const blocks = get(node, `blocks`);
    this.slug = get(node, `slug`);
    this.title = get(node, `title`);
    this.squareImage = new Img(get(node, `squareImage`));
    this.jumpText = get(node, `subText.json`);
    this.mainImage = new Img(get(node, `mainImage`));
    this.subText = get(node, `subText.json`);
    this.block = blocks ? new Block(blocks) : undefined;
  }
}
